export var EasingOption;
(function (EasingOption) {
    EasingOption["ease"] = "ease";
    EasingOption["linear"] = "linear";
    EasingOption["ease_in"] = "ease-in";
    EasingOption["ease_out"] = "ease-out";
    EasingOption["ease_out_in"] = "ease-out-in";
})(EasingOption || (EasingOption = {}));
